import comp from "./LogoutModal";
export default comp;
